module.exports = __webpack_public_path__ + "static/media/financial_consulting.672fc68a.svg";